export const CROWDFUNDING_PROJECTS = [
    {
        id: 'cp-1',
        title: 'Grassroots Pitch Initiative',
        description: 'Building sustainable pitches for local girls teams in underserved communities.',
        goal: 50000,
        current: 32500,
        duration: '30 days',
        image: 'https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=800&q=80',
        category: 'Infrastructure'
    }
    // ... other projects follow the same structure
];